import {Component, HostBinding} from "@angular/core";

@Component({
  selector: "core-hostbinding",
  template: `
    <usecase-container title="HostBinding" src="core/hostbinding">
      <usecase-content>
        <input type="checkbox" (change)="onChange($event.target.checked)">
        <span>色が変わるよ</span>
      </usecase-content>
    </usecase-container>
  `,
  styles: [`.red { "color": red; } .black { "color": black; }`]
})
export class HostBindingComponent {
  @HostBinding("style.color") color = "black";

  onChange(value: boolean) {
    if (value) {
      this.color = "red";
    } else {
      this.color = "black";
    }
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/hostbinding/component.ts
 **/